import { Head } from "@inertiajs/react";
import { AppShell } from "@/components/AppShell";
import { DesignSystem } from "@/components/design-system/DesignSystem";

interface AdminDesignSystemProps {
  section: "branding" | "structure" | "elements" | "base-styles";
}

const SECTION_TITLES: Record<string, string> = {
  branding: "Branding",
  structure: "Structure",
  elements: "Elements",
  "base-styles": "Base Styles",
};

const SECTION_DESCRIPTIONS: Record<string, string> = {
  branding: "Design system reference for branding, containing colors and typography.",
  structure: "Design system reference for page structure, layout shells, headers, body content, and footers.",
  elements: "Design system reference for elements, including iconography, buttons, forms, lists, modals, and dropdowns.",
  "base-styles": "Design system reference for base element styles, including heading scale, anchors, paragraphs, lists, and rules.",
};

export default function AdminDesignSystem({ section }: AdminDesignSystemProps) {
  const displayTitle = `Design System — ${SECTION_TITLES[section] || "Branding"}`;
  const displayDescription = SECTION_DESCRIPTIONS[section] || "Internal reference for every visual primitive in this app.";

  return (
    <>
      <Head title={displayTitle}>
        <meta name="description" content={displayDescription} />
        <meta property="og:title" content={displayTitle} />
        <meta property="og:description" content={displayDescription} />
      </Head>
      <AppShell full>
        <DesignSystem section={section} />
      </AppShell>
    </>
  );
}
